import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from './header.js';
import Footer from "./footer.js";

import '../styles/index.scss';

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Kündigungschecker"
      meta={[
        { name: 'description', content: 'Schnelltest, ob Ihre Kündigung rechtens ist.' },
        { name: 'keywords', content: 'kündigung, recht, unwirksam, entlassung, check' },
        { "http-equiv": "cache-control", "content": "no-cache, must-revalidate, post-check=0, pre-check=0" },  
        { "http-equiv": "cache-control", "content": "max-age=0" },
        { "http-equiv": "expires", "content": "0" },  
        { "http-equiv": "expires", "content": "Tue, 01 Jan 1980 1:00:00 GMT" },  
        { "http-equiv": "pragma", "content": "no-cache" },
      ]}
    />

    <Header />

    <main className="main">
      {children()}
    </main>

    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js